const status = [
    {value: 'Paid',text: 'Paid'},
    {value: 'Pending', text: 'Pending'}
]

export default status;